import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

// Routes
import { NOTIFICATIONS } from '@/routes/privateRoutes';

// Hooks
import useToastsNotifications from '@/utils/hooks/swr/notifications/useToastsNotifications';

// Components
import Icon from '@/components/base/Icon';
import NotificationsCounter from '@/components/base/NotificationsCounter';

type MenuNotificationsProps = {
    size?: 'xl' | 'base';
};

const MenuNotifications = ({ size = 'xl' }: MenuNotificationsProps) => {
    const { pathname } = useRouter();
    const urlWithoutParam = pathname.split('?')[0];
    const isActive = urlWithoutParam === NOTIFICATIONS;

    const { unreadNotifications, hasUnreadNotifications } = useToastsNotifications({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    return (
        <Link
            href={NOTIFICATIONS}
            className={clsx('group relative', {
                'text-xl': size === 'xl',
                'text-base': size === 'base'
            })}>
            <span className="flex items-center justify-center">
                <Icon
                    icon={isActive ? 'notification-on' : 'notification'}
                    className={clsx({
                        'text-icoBlue': isActive,
                        'text-icoGray-500 group-hover:text-icoBlue dark:text-icoDarkMode-wolf group-hover:dark:text-icoBlue':
                            !isActive
                    })}
                />
                {hasUnreadNotifications ? (
                    <NotificationsCounter className="absolute -right-2.5 -top-2 flex items-center justify-center">
                        {unreadNotifications > 20 ? '20+' : unreadNotifications}
                    </NotificationsCounter>
                ) : null}
            </span>
        </Link>
    );
};

export default MenuNotifications;
